// Stack.tsx
import { type ReactNode, type CSSProperties, type HTMLAttributes } from "react";
import "./Stack.css";
import { Center } from "../center/Center";

interface StackProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  gap?: number | string;
}

export const Stack = ({ children, gap, style }: StackProps) => {
  const inlineStyles: CSSProperties = {
    "--stack-gap": gap,
    ...style,
  } as CSSProperties;

  return (
    <div className="stack" style={inlineStyles}>
      {children}
    </div>
  );
};
